import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({}));

export default style;
